import { isEqual } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

import { ADDRESS_PAGE } from '@constants/formNames';
import { SUBMITTED_ADDRESS_PAGE_VALUES } from '@constants/storageKeys';
import { AddressPageFormValues } from '@features/Address/types';

const useInitialAddressStore = () => {
  const [address, setAddress] = useState<Nullable<AddressPageFormValues>>(null);

  useEffect(() => {
    const initialValues = window.sessionStorage.getItem(
      SUBMITTED_ADDRESS_PAGE_VALUES
    );

    if (initialValues) {
      setAddress(JSON.parse(initialValues));
    }
  }, []);

  const hasAddressChanged = useCallback(
    // decided to use unknown because passed values use Maybe generic type
    (formValues: unknown) => {
      if (!address) {
        return true;
      }

      return !isEqual(address[ADDRESS_PAGE], formValues);
    },
    [address]
  );

  const storeSubmittedAddress = (formValues: unknown) => {
    window.sessionStorage.setItem(
      SUBMITTED_ADDRESS_PAGE_VALUES,
      JSON.stringify({
        [ADDRESS_PAGE]: formValues,
      })
    );
  };

  return { hasAddressChanged, storeSubmittedAddress };
};

export { useInitialAddressStore };
